import { useEffect, useState } from "react";
import { ClipboardList, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const SEL = "w-full h-8 rounded border border-slate-300 bg-white text-sm text-slate-800 px-2";

// Invio di un Form (WhatsApp Flow pubblicato) dalla Chat: finestra 24h aperta → interattivo, altrimenti template approvato.
export const FormSendDialog = ({ open, onClose, contact, isOpenWindow, onSent }) => {
  const [forms, setForms] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [formId, setFormId] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [meta, setMeta] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/forms/published").then((r) => { setForms(r.data.items); setMeta(r.data.meta || {}); }).catch(() => setForms([]));
    api.get("/templates").then((r) => setTemplates((Array.isArray(r.data) ? r.data : r.data.items || []).filter((t) => t.status === "approved"))).catch(() => setTemplates([]));
  }, [open]);

  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/forms/${formId}/send`, { phone: contact.phone, template_id: templateId || null });
      toast.success(r.data.duplicate ? "Form già inviato oggi a questo contatto (nessun doppio invio)" : `Form inviato${r.data.mode === "mock" ? " (MOCK, nessun invio reale)" : ""}`);
      onSent?.(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail ?? e?.message)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="form-send-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-base"><ClipboardList className="w-4 h-4" /> Invia un Form (WhatsApp Flow)</DialogTitle></DialogHeader>
        {meta.mode === "mock" && <p className="text-[11px] px-2 py-1 rounded bg-amber-100 text-amber-800" data-testid="form-send-mock">Modalità MOCK: nessun messaggio reale viene inviato in questo ambiente.</p>}
        <label className="block text-xs text-slate-400">Form pubblicato</label>
        <select className={SEL} value={formId} onChange={(e) => setFormId(e.target.value)} data-testid="form-send-select">
          <option value="">— scegli —</option>{forms.map((f) => <option key={f.id} value={f.id}>{f.name} · v{f.published_version}</option>)}
        </select>
        {forms.length === 0 && <p className="text-xs text-slate-500" data-testid="form-send-empty">Nessun Form pubblicato: pubblica prima una versione congelata dal costruttore.</p>}
        {!isOpenWindow && <>
          <label className="block text-xs text-slate-400">Finestra 24h chiusa: template approvato con pulsante Flow</label>
          <select className={SEL} value={templateId} onChange={(e) => setTemplateId(e.target.value)} data-testid="form-send-template">
            <option value="">— scegli —</option>{templates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </>}
        <Button onClick={send} disabled={busy || !formId || (!isOpenWindow && !templateId)} className="w-full" data-testid="form-send-submit">{busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />} Invia Form</Button>
      </DialogContent>
    </Dialog>
  );
};
